import { regNrMaskFilter } from '../../mixins/regNrMask'

export default {
  computed: {
    turtasRusisList() {
      return Object.keys(this.turtasInfoList).map(key => {
        return {
          value: key,
          text: this.turtasInfoList[key].title,
        }
      })
    },
    turtasRusisIsrasasList() {
      return Object.keys(this.turtasInfoIsrasasList).map(key => {
        return {
          value: key,
          text: this.turtasInfoIsrasasList[key].title,
        }
      })
    },
    compTurtasRusis() {
      return this.mainData
        ? this.mainData.tur_rusis
        : this.parametrai.tur_rusis ?? false
    },
    turtasRusisTitle() {
      return this.turtasInfo.title
    },
    turtasInfo() {
      return this.compTurtasRusis
        ? this.turtasInfoList[this.compTurtasRusis] ?? {}
        : {}
    },
    turtasInfoIsrasasList() {
      return {
        ntr: {
          title: 'Nekilnojamasis turtas (NTR objektas)',
          confirmText: 'Nekilnojamasis turtas (NTR objektas)',
          search1: 'Registro numeris',
          search1Tooltip: 'Paieška. Turtas. NTR. Registro numeris',
          search1Field: 'reg_nr',
          placeholder1: '##/#########',
          mask1: regNrMaskFilter,
        },
      }
    },
    turtasInfoList() {
      return {
        ntr: {
          title: 'Nekilnojamasis turtas (NTR objektas)',
          confirmText: 'Nekilnojamasis turtas (NTR objektas)',
          search1: 'Registro numeris',
          search1Tooltip: this.isIsrasasNtr
            ? 'Paieška. Turtas. NTR išrašas. Registro numeris'
            : 'Paieška. Turtas. NTR. Registro numeris',
          search1Field: 'reg_nr',
          placeholder1: '##/#########',
          mask1: regNrMaskFilter,
          search2: 'Žemės sklypo ar statinio unikalus numeris',
          search2Tooltip:
            'Paieška. Turtas. NTR. Žemės sklypo ar statinio unikalus numeris',
          search2Field: 'tur_identifikatorius',
        },
        ktp: {
          title: 'Transporto priemonė',
          confirmText: 'Transporto priemonę',
          search1: 'Identifikavimo numeris suteiktas gamintojo (VIN kodas)',
          search1Tooltip:
            'Paieška. Turtas. Transporto priemonė. Identifikavimo numeris',
          search2: 'Valstybinis numeris',
          search2Tooltip:
            'Paieška. Turtas. Transporto priemonė. Valstybinis numeris',
          search2Field: 'tur_ktp_valstybinis_numeris',
        },
        orlaivis: {
          title: 'Orlaivis',
          confirmText: 'Orlaivis',
          search1: 'Identifikavimo kodas',
          search1Tooltip: 'Paieška. Turtas. Orlaivis. Identifikavimo kodas',
          search2: 'Orlaivio nacionalinis ir registracijos ženklai',
          search2Tooltip:
            'Paieška. Turtas. Orlaivis. Orlaivio nacionalinis ir registracijos ženklai',
          search2Field: 'tur_orlaivis_registracijos_zenklas',
        },
        traktorius: {
          title: 'Traktorius ar kita mašina',
          confirmText: 'Traktorius ar kita mašina',
          search1: 'Unikalus atpažinties kodas',
          search1Tooltip:
            'Paieška. Turtas. Traktorius ar kita mašina. Unikalus atpažinties kodas',
        },
        prekes_zenklas: {
          title: 'Prekių ženklas',
          confirmText: 'Prekių ženklas',
          search1: 'Ženklo registracijos numeris / Paraiškos numeris',
          search1Tooltip:
            'Paieška. Turtas. Prekių ženklas. Ženklo registracijos numeris / Paraiškos numeris',
        },
        dizainas: {
          title: 'Dizainas',
          confirmText: 'Dizainas',
          search1: 'Dizaino registracijos numeris / Paraiškos numeris',
          search1Tooltip:
            'Paieška. Turtas. Dizainas. Dizaino registracijos numeris / Paraiškos numeris',
        },
        patentas: {
          title: 'Patentas',
          confirmText: 'Patentas',
          search1: 'Patento registracijos numeris',
          search1Tooltip:
            'Paieška. Turtas. Patentas. Patento registracijos numeris',
        },
        vagonas: {
          title: 'Geležinkelių riedmuo',
          confirmText: 'Geležinkelių riedmuo',
          search1: 'Identifikacijos numeris',
          search1Tooltip:
            'Paieška. Turtas. Geležinkelių riedmuo. Identifikacijos numeris',
        },
        ginklas: {
          title: 'Ginklai',
          confirmText: 'Ginklai',
          search1: 'Identifikavimo kodas',
          search1Tooltip: 'Paieška. Turtas. Ginklai. Identifikavimo kodas',
          search2: 'Ginklo numeris',
          search2Tooltip: 'Paieška. Turtas. Ginklai. Ginklo numeris',
          search2Field: 'tur_ginklas_numeris',
        },
        imone: {
          title: 'Įmonė',
          confirmText: 'Įmonė',
          search1: 'Juridinio asmens kodas',
          search1Tooltip: 'Paieška. Turtas. Įmonė. Juridinio asmens kodas',
        },
        juru_laivas: {
          title: 'Jūrų laivas / Vidaus vandenų transporto priemonė',
          confirmText: 'Jūrų laivas',
          search1: 'Identifikavimo kodas',
          search1Tooltip: 'Paieška. Turtas. Jūrų laivas. Identifikavimo kodas',
          search2: 'Registracijos numeris',
          search2Tooltip: 'Paieška. Turtas. Jūrų laivas. Registracijos numeris',
          search2Field: 'tur_juru_laivas_registracijos_numeris',
        },
        // laivelis: {
        //   title: 'Vidaus vandenų transporto priemonė',
        //   confirmText: 'Vidaus vandenų transporto priemonė',
        //   search1: 'Identifikavimo kodas',
        //   search1Tooltip:
        //     'Paieška. Turtas. Vidaus vandenų transporto priemonė. Identifikavimo kodas',
        //   search2: 'Registro (identifikavimo) numeris',
        //   search2Tooltip:
        //     'Paieška. Turtas. Vidaus vandenų transporto priemonė. Registracijos numeris',
        //   search2Field: 'tur_laivelis_registracijos_numeris',
        // },
        banko_saskaita: {
          title: 'Lėšos banko sąskaitoje',
          confirmText: 'Lėšos banko sąskaitoje',
          search1: 'Sąskaitos numeris',
          search1Tooltip:
            'Paieška. Turtas. Lėšos banko sąskaitoje. Sąskaitos numeris',
          mask1: 'AA## ##### ###########',
          placeholder1: 'LT## ##### ###########',
        },
      }
    },
    search1() {
      return this.turtasInfo.search1 ?? null
    },
    search1Key() {
      return `${this.compTurtasRusis}_search1`
    },
    search1Field() {
      return this.compTurtasRusis === 'ntr' ? 'reg_nr' : 'tur_identifikatorius'
    },
    search1Tooltip() {
      return this.turtasInfo.search1Tooltip ?? null
    },
    mask1() {
      return this.turtasInfo.mask1 ?? null
    },
    placeholder1() {
      return this.turtasInfo.placeholder1 ?? ' '
    },
    search2() {
      return this.turtasInfo.search2 ?? null
    },
    search2Key() {
      return `${this.compTurtasRusis}_search2`
    },
    search2Field() {
      return this.turtasInfo.search2Field ?? null
    },
    search2Tooltip() {
      return this.turtasInfo.search2Tooltip ?? null
    },
  },
  watch: {
    compTurtasRusis() {
      this.$emit('turtasRusisText', this.turtasInfo.confirmText)
    },
  },
}
